import { render } from "./horizontalCard.vue?vue&type=template&id=680945dd&scoped=true"
import script from "./horizontalCard.vue?vue&type=script&lang=js"
export * from "./horizontalCard.vue?vue&type=script&lang=js"

import "./horizontalCard.vue?vue&type=style&index=0&id=680945dd&scoped=true&lang=css"

import exportComponent from "/home/LiuJing/code/MyProjects/YiZhiWang/yizhiwang_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-680945dd"]])

export default __exports__